import { Outlet } from 'react-router-dom';
import HeaderLogin from './Header/HeaderLogin';
import Footer from "../layout/Footer/Footer";

export default function AuthLayout() {
    return (
        <div className="min-h-screen flex flex-col justify-between bg-gray-100">
            <HeaderLogin />
            <main className="flex-1 flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <Outlet />
                </div>
            </main>
            <Footer />
        </div>
    );
};